const W = 620;
const H = 140;
const PAD = { l: 30, r: 10, t: 10, b: 22 };

/** Simple vertical bar chart for counts (e.g. readings per day). Theme-aware via CSS vars. */
export default function BarChart({ data }: { data: Array<{ label: string; value: number }> }) {
  if (!data.length) return <div className="chartEmpty">No data.</div>;
  const max = Math.max(1, ...data.map((d) => d.value));
  const bw = (W - PAD.l - PAD.r) / data.length;
  const y = (v: number) => H - PAD.b - (v / max) * (H - PAD.t - PAD.b);
  // keep the x-axis label count readable on long ranges
  const stride = Math.ceil(data.length / 14);

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="metricChart barChart" role="img">
      {[0, max].map((v) => (
        <g key={v}>
          <line className="grid" x1={PAD.l} x2={W - PAD.r} y1={y(v)} y2={y(v)} />
          <text className="axis" x={PAD.l - 5} y={y(v) + 3} textAnchor="end">{v}</text>
        </g>
      ))}
      {data.map((d, i) => (
        <g key={i}>
          <rect className="bar" x={PAD.l + i * bw + bw * 0.15} y={y(d.value)} width={bw * 0.7}
            height={Math.max(0, H - PAD.b - y(d.value))} rx={2} />
          {i % stride === 0 && (
            <text className="axis" x={PAD.l + i * bw + bw / 2} y={H - 7} textAnchor="middle">{d.label}</text>
          )}
        </g>
      ))}
    </svg>
  );
}
